import React from "react";
import ReactPaginate from "react-paginate";

const clamp = (n, lo, hi) => Math.max(lo, Math.min(hi, n));

const Pager = ({ page = 1, totalPages = 0, onChange }) => {
  const pageCount = Number(totalPages) || 0;

  // page is 1-based in your app; react-paginate wants 0-based
  const zeroBased = (Number(page) || 1) - 1;

  // only provide forcePage when there are pages (otherwise react-paginate warns)
  const forcePage =
    pageCount > 0 ? clamp(zeroBased, 0, pageCount - 1) : undefined;

  return (
    <nav className="d-flex flex-row justify-content-center text-success">
      <ReactPaginate
        className="pagination rounded-sm"
        pageClassName="page-item"
        pageLinkClassName="page-link text-success"
        activeClassName="fw-bold active"
        activeLinkClassName="bg-success border-success text-white"
        forcePage={forcePage}
        breakLabel=""
        nextLabel=""
        previousLabel=""
        onPageChange={(evt) => onChange?.(evt.selected + 1)} // back to 1-based
        pageRangeDisplayed={5}
        pageCount={pageCount}
        renderOnZeroPageCount={null}
      />
    </nav>
  );
};

export default Pager;
